import { toast } from "react-toastify";
import firebase from "../../config/firebase";
import axios from "axios";

export const searchManager =
  (id, onComplete = () => {}) =>
  async (dispatch) => {
    firebase
      .firestore()
      .collection("users")
      .where("managerID", "==", id)
      .get()
      .then(async (query) => {
        if (query.empty) {
          onComplete();
          toast.warning("Please Enter valid manager id ");
        } else {
          let manager_data = [];
          for await (let doc of query.docs) {
            manager_data.push({ id: doc.id, ...doc.data() });
          }
          dispatch({
            type: "SEARCH_MANAGER",
            payload: manager_data,
          });
          onComplete();
          toast.success("Get manager data successfully ");
        }
      });
  };

export const clearSearch = () => (dispatch) => {
  dispatch({
    type: "CLEAR_SEARCH_MANAGER",
  });
  toast.success("Clear data successfully ");
};
export const getSeasonalManagerRatings =
  (managerEmail, onComplete = () => {}) =>
  (dispatch) => {
    firebase
      .firestore()
      .collection("seasonal_badges")
      .where("managerEmail", "==", managerEmail)
      .where("managerRating", "==", true)
      .get()
      .then(async (query) => {
        let data = [];
        let totalRating = {
          satisfied: 0,
          unSatisfied: 0,
          rating: 0,
          totalReviews: 0,
        };
        for await (let doc of query.docs) {
          let athlete = await firebase
            .firestore()
            .collection("users")
            .doc(doc.data().athlete_id)
            .get();
          data.push({ id: doc.id, ...doc.data(), athleteData: athlete.data() });
          totalRating.satisfied += doc.data().satisfactory == "Satisfied" || 0;
          totalRating.unSatisfied +=
            doc.data().satisfactory == "Unsatisfied" || 0;
          totalRating.rating += doc.data().rating || 0;
          totalRating.totalReviews += 1;
        }
        dispatch({
          type: "MANAGER_SEASONAL_RATING",
          payload: { data, totalRating },
        });
        onComplete();
      });
  };
export const getMomentoManagerRatings =
  (managerEmail, onComplete = () => {}) =>
  (dispatch) => {
    firebase
      .firestore()
      .collection("momentos")
      .where("managerEmail", "==", managerEmail)
      .where("managerRating", "==", true)
      .get()
      .then(async (query) => {
        let data = [];
        let totalRating = {
          satisfied: 0,
          unSatisfied: 0,
          rating: 0,
          totalReviews: 0,
        };
        for await (let doc of query.docs) {
          let athlete = await firebase
            .firestore()
            .collection("users")
            .doc(doc.data().athlete_id)
            .get();
          data.push({ id: doc.id, ...doc.data(), athleteData: athlete.data() });
          totalRating.satisfied += doc.data().satisfactory == "Satisfied" || 0;
          totalRating.unSatisfied +=
            doc.data().satisfactory == "Unsatisfied" || 0;
          totalRating.rating += doc.data().rating || 0;
          totalRating.totalReviews += 1;
        }
        dispatch({
          type: "MANAGER_MOMENTO_RATING",
          payload: { data, totalRating },
        });
        onComplete();
      });
  };

export const getTalkingManagerRatings =
  (managerEmail, onComplete = () => {}) =>
  (dispatch) => {
    firebase
      .firestore()
      .collection("talking_badges")
      .where("managerEmail", "==", managerEmail)
      .where("managerRating", "==", true)
      .get()
      .then(async (query) => {
        let data = [];
        let totalRating = {
          satisfied: 0,
          unSatisfied: 0,
          rating: 0,
          totalReviews: 0,
        };
        for await (let doc of query.docs) {
          let athlete = await firebase
            .firestore()
            .collection("users")
            .doc(doc.data().athleteId)
            .get();
          data.push({ id: doc.id, ...doc.data(), athleteData: athlete.data() });
          totalRating.satisfied += doc.data().satisfactory == "Satisfied" || 0;
          totalRating.unSatisfied +=
            doc.data().satisfactory == "Unsatisfied" || 0;
          totalRating.rating += doc.data().rating || 0;
          totalRating.totalReviews += 1;
        }
        dispatch({
          type: "MANAGER_TALKING_RATING",
          payload: { data, totalRating },
        });
        onComplete();
      });
  };

export const getGroupChatManagerRatings =
  (managerUid, onComplete = () => {}) =>
  (dispatch) => {
    firebase
      .firestore()
      .collection("a4b_chat_rating")
      .where("to_id", "==", managerUid)
      .get()
      .then(async (query) => {
        let data = [];
        let totalRating = {
          S: 0,
          NS: 0,
          RST: 0,
        };
        for await (let doc of query.docs) {
          let athlete = await firebase
            .firestore()
            .collection("users")
            .doc(doc.data().from_id)
            .get();
          let chat = await firebase
            .firestore()
            .collection("new_a4b_chat")
            .doc(doc.data().chatId)
            .get();
          data.push({
            id: doc.id,
            ...doc.data(),
            athleteData: athlete.data(),
            created_at: chat.data().created_at,
          });
          totalRating.S += doc.data().chatResponse == "satisfied" || 0;
          totalRating.NS += doc.data().chatResponse == "NS" || 0;
          totalRating.RST += doc.data().chatResponse == "RST" || 0;
        }
        dispatch({
          type: "MANAGER_CHAT_RATING",
          payload: { data, totalRating },
        });
        onComplete();
      });
  };

export const sendManagerEmail =
  (data, onComplete = () => {}) =>
  async () => {
    const options = {
      to: data.to || data.email, // supports both "to" and old "email"
      subject: data.subject || "Athlete Email For Manager",
      text: data.text,
    };

    await axios.post(
      "https://us-central1-fans-help-players.cloudfunctions.net/app/sendUserEmail",
      options
    );

    onComplete();
  };


export const getManagerTotalRating = (id) => async (dispatch) => {
  firebase
    .firestore()
    .collection("manager_stats")
    .where("managerId", "==", id)
    .get()
    .then(async (query) => {
      dispatch({
        type: "GET_MANAGER_STATS",
        payload: query.empty ? {} : query.docs[0]?.data(),
      });
    });
};

export const getStrategyRating =
  (email, onComplete = () => {}) =>
  async (dispatch) => {
    firebase
      .firestore()
      .collection("strategy-rating")
      .where("managerEmail", "==", email)
      .get()
      .then(async (query) => {
        let temp_data = [];
        for await (let doc of query.docs) {
          temp_data.push({ id: doc.id, ...doc.data() });
        }
        dispatch({
          type: "GET_STRATEGY_RATING",
          payload: temp_data,
        });
        onComplete();
      });
  };

export const addManagersRequests =
  (data, onSuccess = () => {}) =>
  async (dispatch) => {
    try {
      let docRef = await firebase
        .firestore()
        .collection("request_manager_teach")
        .add(data);
      const newRequest = { id: docRef.id, ...data };

      dispatch({
        type: "ADD_REQUEST",
        payload: newRequest,
      });
      toast.success("Request Added Successfully");
      onSuccess("success");
    } catch (error) {
      onSuccess();
      console.error("Error adding document: ", error);
    }
  };

export const fetchManagersRequests =
  (id, lastDoc, onSuccess = () => {}) =>
  async (dispatch) => {
    try {
      let query = firebase
        .firestore()
        .collection("request_manager_teach")
        .where("requestedId", "==", id)
        .limit(5);
      if (lastDoc) {
        query = query.startAfter(lastDoc);
      }
      await query.get().then(async (quary) => {
        let data = [];
        for await (let doc of quary.docs) {
          data.push({ id: doc.id, ...doc.data() });
        }
        const lastVisible = quary.docs[quary.docs.length - 1];
        const hasMore = data.length === 5;
        dispatch({
          type: lastDoc
            ? "FETCH_REQUEST_MANAGER_LOAD_MORE"
            : "FETCH_REQUEST_MANAGER",
          payload: { data, lastVisible, hasMore },
        });
        onSuccess();
      });
    } catch (error) {
      console.error("Error fetching documents: ", error);
      onSuccess();
    }
  };

export const deleteRequest =
  (id, onSuccess = () => {}) =>
  async (dispatch) => {
    try {
      await firebase
        .firestore()
        .collection("request_manager_teach")
        .doc(id)
        .delete();

      dispatch({
        type: "DELETE_REQUEST",
        payload: id,
      });
      toast.success("Request deleted successfully");
      onSuccess();
    } catch (error) {
      console.error("Error deleting document: ", error);
    }
  };

export const editRequest =
  (id, updatedData, onSuccess = () => {}) =>
  async (dispatch) => {
    try {
      await firebase
        .firestore()
        .collection("request_manager_teach")
        .doc(id)
        .update(updatedData);

      dispatch({
        type: "EDIT_REQUEST",
        payload: { id, ...updatedData },
      });
      toast.success("Updated Successfully");
      onSuccess("success");
    } catch (error) {
      console.error("Error updating document: ", error);
    }
  };
